import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';

import { PrintService } from '../print/print.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';

@Component({
    selector: 'shelf',
    providers: [StorageService, PrintService],
    templateUrl: './shelf.component.html',
    styleUrls: ['./shelf.component.scss']
  })
  export class ShelfComponent implements AfterViewInit, OnInit {

    shelfs: any[] = [];
    filteredShelfs: any[];
    filterTitle: string;
    filterString: string = '';
  
    constructor(private _titleService: Title,
      private _loadingService: TdLoadingService,
      private _storageService: StorageService,
      private _printService: PrintService,
      private _router: Router,
      private _dialogService: TdDialogService,
      private _snackBarService: MdSnackBar,
      private _changeDetectorRef: ChangeDetectorRef,
      public media: TdMediaService) {
    }
  
    ngOnInit(): void {
      this._titleService.setTitle('Shelf');
      this.load();
    }
  
    loadFilter(filterTitle: string) {
      this.filterTitle = filterTitle;
      this.filterShelfs(this.filterString);
    }
  
    ngAfterViewInit(): void {
      // broadcast to all listener observables when loading the page
      this.media.broadcast();
      // force a new change detection cycle since change detections
      // have finished when `ngAfterViewInit` is executed
      this._changeDetectorRef.detectChanges();
    }
  
    filterShelfs(value: string = ''): void { //load not deleted shelfs
      this.filterString = value;
      this.filteredShelfs = this.shelfs.filter((shelf: any) => {
          return (this.filterString == '') ||
                 (shelf.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
       });
    }
  
  
    async load(): Promise<void> {
      try {
        this._loadingService.register('shelf.list');
        this.shelfs = await this._storageService.getContainers('SHELF').toPromise();
        this.shelfs = this.shelfs.filter((container: any) => {
          return (container.containerStatus.indexOf('DELETED') == -1);
       });
        this.loadFilter('All shelfs');    
      } catch (error) {
  
      } finally {
        this.filteredShelfs = Object.assign([], this.shelfs);
        this._loadingService.resolve('shelf.list');
      }
    }
  
    deleteShelf(shelf: any): void {
      this._dialogService
        .openConfirm({message: 'Are you sure you want to delete the shelf?'})
        .afterClosed().toPromise().then((confirm: boolean) => {
          if (confirm) {
            this._deleteShelf(shelf);
          }
        });
    }
  
    private async _deleteShelf(shelf: any): Promise<void> {
      try {
        this._loadingService.register('shelf.list');
        await this._storageService.deleteContainer(shelf).toPromise();
        this._snackBarService.open('Shelf deleted', 'Ok');
        this.load();
      } catch (error) {
        this._dialogService.openAlert({message: 'There was an error trying to delete the shelf'});
      } finally {
        this._loadingService.resolve('shelf.list');
      }
    }
  
    printShelfLabel(shelf: any): void {
      this._dialogService
        .openConfirm({message: 'PRINT ' + shelf.name})
        .afterClosed().toPromise().then((confirm: boolean) => {
          if (confirm) {
            this._printShelfLabel(shelf.name);
          }
        });
      
    }  
  
    private async _printShelfLabel(shelfName: string): Promise<void> {
      try {
        this._loadingService.register('shelf.list');
        await this._storageService.getContainerLabel(shelfName).toPromise();
        await this.sleep(1000);
        await this._printService.print('labelPrinter', shelfName).toPromise();
        this._snackBarService.open('Print', 'OK');
        this.load();
      } catch (error) {
         this._dialogService.openAlert({message: 'There was an error trying to print the shelf'});
      } finally {
        this._loadingService.resolve('shelf.list');
      }
    }

    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    }
  
  }
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/shelf/shelf.component.ts